import { VALIDATION_STATUSES } from "../constants";
const { INVALID, VALID, EMPTY } = VALIDATION_STATUSES;

function isInvalid(x) {
  return x === INVALID;
}
function isValid(x) {
  return x === VALID;
}
function isEmpty(x) {
  return x === EMPTY;
}
function isFieldValid(x) {
  return isValid(x.validationStatus);
}
function hasValue(arr, value) {
  return arr && arr.some((v) => v === value);
}

export { isInvalid, isValid, isEmpty, isFieldValid, hasValue };
